// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BinocularsBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.125 18.831v-.006a6.412 6.412 0 0 0-.316-.738L24.616 6.273a1.497 1.497 0 0 0-.312-.457 4.5 4.5 0 0 0-6.365 0 1.5 1.5 0 0 0-.439 1.059V9.5h-3V6.875a1.5 1.5 0 0 0-.439-1.06 4.5 4.5 0 0 0-6.365 0 1.5 1.5 0 0 0-.312.456L2.19 18.087c-.12.24-.226.486-.316.738v.006A6.5 6.5 0 1 0 14.5 21v-8.5h3V21a6.501 6.501 0 1 0 12.625-2.169ZM10 7.785a1.5 1.5 0 0 1 1.5-.152v7.893a6.488 6.488 0 0 0-4.487-.952L10 7.785ZM8 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7ZM20.5 7.633a1.507 1.507 0 0 1 1.5.152l2.984 6.789a6.488 6.488 0 0 0-4.488.952l.004-7.893ZM24 24.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
